export default __webpack_public_path__ + "static/media/mobile_banner_cancellations.5a474d4e.jpg";